import {VideoEventAbstract} from 'app/components/tv/events/VideoEvent';

export default class AdFinishedEvent extends VideoEventAbstract {}
